import { createAction } from 'redux-create-action';
import { ACTIONS } from './constants';

export const initContainer = createAction(ACTIONS.INIT_CONTAINER);
export const exitContainer = createAction(ACTIONS.EXIT_CONTAINER);


export const loadInventoryAts = createAction(ACTIONS.LOAD_INVENTORY_ATS);
export const loadInventoryAtsSuccess = createAction(ACTIONS.LOAD_INVENTORY_ATS_SUCCESS, 'payload');
export const loadInventoryAtsError = createAction(
  ACTIONS.LOAD_INVENTORY_ATS_ERROR,
  'errorMessage',
  'error',
);
export const setIsFetchingFeed = createAction(ACTIONS.SET_IS_FETCHING_FEED, 'isFetchingFeed');
export const loadFeed = createAction(ACTIONS.LOAD_FEED);
export const setColumns = createAction(ACTIONS.SET_COLUMNS, 'columns');
export const setColumnsOrder = createAction(ACTIONS.SET_COLUMNS_ORDER, 'columnsOrder');
export const setColumnEnabled = createAction(ACTIONS.SET_COLUMN_ENABLED, 'columnId', 'enabled');

export const setItemsPerPage = createAction(ACTIONS.SET_ITEMS_PER_PAGE, 'itemsPerPage');

export const showOptionsModal = createAction(ACTIONS.SHOW_OPTIONS_MODAL, 'showOptionsModal');
export const refreshInventoryFeed = createAction(ACTIONS.REFRESH_INVENTORY_FEED);
export const sortInventoryFeed = createAction(ACTIONS.SORT_INVENTORY_FEED, 'columnId', 'direction');
export const setFilterOperand = createAction(ACTIONS.SET_FILTER_OPERAND, 'operand');
export const unsetFilterOperand = createAction(
  ACTIONS.UNSET_FILTER_OPERAND,
  'groupIndex',
  'filterIndex',
);
export const setShipTypes = 
createAction(ACTIONS.SET_SHIP_TYPES, 'shipTypes');
export const addShipType = createAction(ACTIONS.ADD_SHIP_TYPE, 'shipType');
export const removeShipType = createAction(ACTIONS.REMOVE_SHIP_TYPE, 'shipType');

export const toggleIncludeSpecialZones = 
createAction(ACTIONS.TOGGLE_INCLUDE_SPECIAL_ZONES, 'includeSpecialZones');

export const clearFilters = createAction(ACTIONS.CLEAR_FILTERS);
export const setFilters = createAction(ACTIONS.SET_FILTERS, 'filters');
export const arrangeFilters = createAction(ACTIONS.ARRANGE_FILTERS, 'destination', 'source');

export const goToPage = createAction(ACTIONS.GO_TO_PAGE, 'lastPage');

export const exportToFile = createAction(ACTIONS.EXPORT_TO_FILE);
export const exportToFileSuccess = createAction(ACTIONS.EXPORT_TO_FILE_SUCCESS, 'payload');
export const exportToFileError = createAction(
  ACTIONS.EXPORT_TO_FILE_ERROR,
  'errorMessage',
  'error',
);

export const getFilteredInventoryAtsFeed = createAction(
  ACTIONS.GET_FILTERED_INVENTORY_ATS,
  'params',
  'successActionCallback',
  'errorActionCallback',
);

export const setFilterOptions = createAction(ACTIONS.SET_FILTER_OPTIONS, 'filterOptions');
export const setColumnFilterOptions = createAction(
  ACTIONS.SET_COLUMN_FILTER_OPTIONS,
  'columnFilterOptions',
);
export const setQuickFilterOptions = createAction(
  ACTIONS.SET_QUICK_FILTER_OPTIONS,
  'quickFilterOptions',
);



